import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

function HeroMarketplace() {
  const [title, setTitle] = useState("NFT");
  const location = useLocation();
  
  useEffect(() => {
    if (location.state === "user") {
      setTitle("User");
    }
  }, []);

  return (
    <div>
      <div>
        <div className="hero_marketplace bg_white">
          <div className="container">
            <h1 className="text-center">{title} Marketplace</h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroMarketplace;
